import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { View, Text, Modal, StyleSheet } from "react-native";

// Custom Imports
import t from "@constants/localization";
import { colors } from "@constants/theme";
import PressableButton from "@components/PrimaryButton";
import VacationIcon from "@assets/svg/Vacation/VacationIcon";
import { actions as authActions } from "@reducers/authReducer";
import { fontFamily } from "@utils/styles";
import UpcomingLeaveModal from "./UpcomingLeaveModal";

const PATH = "screens/Vacation/components/OnLeaveModal";

const OnVacationModal = ({ navigation }) => {
  const dispatch = useDispatch();
  const { showVacationModal, vacationDetails } = useSelector(
    (state) => state.auth,
  );

  const [showTodayModal, setShowTodayModal] = useState(
    !!vacationDetails?.TODAY,
  );
  const [showUpcomingModal, setShowUpcomingModal] = useState(
    !!vacationDetails?.UPCOMING,
  );

  if (!vacationDetails?.TODAY && !vacationDetails?.UPCOMING) return null;

  const {
    title = t(`${PATH}/title`),
    buttons = [
      {
        text: t(`${PATH}/okay`),
        action: "okCta",
      },
    ],
  } = vacationDetails?.TODAY || {};

  const closeModal = async () => {
    dispatch(authActions.showVacationModal(false));
  };

  const updateTodayModal = async () => {
    if (showUpcomingModal) {
      setShowTodayModal(false);
    } else {
      await closeModal();
      setShowTodayModal(false);
    }
  };

  const updateUpcomingModal = async () => {
    await closeModal();
    setShowUpcomingModal(false);
  };

  const onEditPress = () => {
    const { vacation_date, vacation_type } = vacationDetails?.UPCOMING || {};
    navigation &&
      navigation.navigate("VacationCalendar", {
        isEdit: true,
        vacation_date,
        type: vacation_type,
      });
  };

  const shouldShowVacationModal =
    showVacationModal && (showTodayModal || showUpcomingModal);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={shouldShowVacationModal}
    >
      <View style={styles.modalWrapper}>
        {showTodayModal ? (
          <View style={styles.container}>
            <VacationIcon width={120} height={80} />
            <Text style={styles.title}>{title}</Text>
            <View style={styles.buttonContainer}>
              <PressableButton
                text={
                  Array.isArray(buttons) && buttons[0].text
                    ? buttons[0]?.text
                    : ""
                }
                buttonStyle={styles.button}
                textStyle={styles.markLeaveBtnText}
                onPress={updateTodayModal}
              />
            </View>
          </View>
        ) : showUpcomingModal ? (
          <UpcomingLeaveModal
            setMainModalVisible={updateUpcomingModal}
            mainModalVisible={showUpcomingModal}
            upcomingData={vacationDetails?.UPCOMING}
            onEditPress={onEditPress}
          />
        ) : null}
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalWrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.lightBlack,
  },
  container: {
    backgroundColor: colors.white,
    paddingTop: 40,
    paddingBottom: 24,
    width: "90%",
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontFamily: fontFamily.semiBold,
    fontSize: 18,
    lineHeight: 27,
    textAlign: "left",
    marginVertical: 16,
  },
  buttonContainer: {
    alignItems: "center",
  },
  button: {
    borderRadius: 6,
    backgroundColor: colors.primary,
    paddingHorizontal: 20,
    paddingTop: 7,
    minWidth: 120,
    paddingBottom: 9,
  },
  markLeaveBtnText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
    color: colors.white,
  },
});

export default OnVacationModal;
